<template>
  <div>
    <svg
      id="pie"
      width="240px"
      height="290px"
      viewbox="0 0 290 290"
      v-html="svgData"
    />
  </div>
</template>

<script>
export default {
  name: 'CircleComponent',
  props: {
    // eslint-disable-next-line vue/require-default-prop
    values: Array,
    // eslint-disable-next-line vue/require-default-prop
    centerText: Array,
    // eslint-disable-next-line vue/require-default-prop
    valueType: String,
  },
  computed: {
    svgData() {
      const fragment = document.createDocumentFragment();

      let donutSvg = null;
      // eslint-disable-next-line
      if (this.values && this.centerText) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        const firstElement = this.values.shift();

        const circle = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'circle'
        );
        circle.setAttribute('r', '105');
        circle.setAttribute('stroke-width', '30');
        circle.setAttribute('stroke', firstElement.color);
        circle.setAttribute('cx', '120');
        circle.setAttribute('cy', '120');
        circle.setAttribute('fill', 'none');
        fragment.appendChild(circle);

        const centerTextGroup = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'g'
        );
        centerTextGroup.setAttribute('transform', 'translate(119,125)');

        // line 1
        const lineOne = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'text'
        );
        lineOne.setAttribute('text-anchor', 'middle');
        lineOne.setAttribute('class', 'label');
        lineOne.setAttribute('fill', '#000');
        lineOne.setAttribute('dy', -30);
        // eslint-disable-next-line prefer-destructuring
        lineOne.innerHTML = this.centerText[0];

        // line 2
        const lineTwo = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'text'
        );
        lineTwo.setAttribute('text-anchor', 'middle');
        lineOne.setAttribute('class', 'label');
        lineTwo.setAttribute('fill', '#3e3e3e');
        lineTwo.setAttribute('dy', -10);

        // eslint-disable-next-line prefer-destructuring
        lineTwo.innerHTML = this.centerText[1];

        // line 3
        const lineThree = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'text'
        );
        lineThree.setAttribute('text-anchor', 'middle');
        lineOne.setAttribute('class', 'value');
        lineTwo.setAttribute('class', 'value');
        lineThree.setAttribute('class', 'amount');
        lineThree.setAttribute('fill', '#000');
        lineThree.setAttribute('dy', 30);

        // eslint-disable-next-line prefer-destructuring
        let lineThreeNum = Number(this.centerText[2]);
        lineThreeNum = Number(lineThreeNum.toFixed());

        if (this.valueType === 'percentage') {
          // eslint-disable-next-line prefer-template
          lineThree.innerHTML = lineThreeNum.toLocaleString() + '%';
        } else {
          // eslint-disable-next-line prefer-template
          lineThree.innerHTML = '$' + lineThreeNum.toLocaleString();
        }
        centerTextGroup.appendChild(lineThree);
        centerTextGroup.appendChild(lineOne);
        centerTextGroup.appendChild(lineTwo);

        fragment.appendChild(centerTextGroup);
      }

      const serializer = new XMLSerializer();
      donutSvg = serializer.serializeToString(fragment);

      return donutSvg;
    },
  },
  methods: {},
};
</script>

<style lang="scss">
circle {
  stroke: #911a58;
}
</style>
